import React from 'react';
import { Lightbulb } from 'lucide-react';

export function HelpJobSearchBestPractices() {
  return (
    <section>
      <div className="flex items-center gap-2 mb-4">
        <Lightbulb className="w-5 h-5 text-amber-500" />
        <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100">Best Practices</h3>
      </div>
      
      <div className="space-y-3">
        <div className="p-4 rounded-xl border border-amber-200/60 dark:border-amber-500/20 bg-amber-100/60 dark:bg-amber-500/5">
          <ul className="space-y-3 text-sm text-slate-800 dark:text-slate-300">
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-1.5 shrink-0" />
              <span><strong>Broaden Your Search:</strong> If you're not getting enough matches, try removing some optional skills or broadening your job title. The AI works best when it has room to find variations.</span>
            </li>
						<li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-1.5 shrink-0" />
              <span><strong>Use Hard Constraints:</strong> List your core skills and specific requirements (like location or seniority) in the tool's form. The AI uses this profile to aggressively filter out jobs missing these requirements, highlighting them as missing strict constraints so you don't waste time on irrelevant postings.</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
